import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ErrorMessage } from "formik";
import { Box, Grid } from "@mui/material";

//import { CheckCircle } from "@mui/icons-material/";

import Field from "../../component/Field";
import Label from "../../component/Label";
import Toaster from "../../component/Toaster";
//import OTPInput from "../../component/OTPInput";
import SelectField from "../../component/SelectField";
import GlobalLoader from "../../component/GlobalLoader";
import { CommonUtil, LoginUserDetails, Product } from "../../util/Utils";

import { useAppDispatch } from "../../store/hooks";
import { studentMasterService } from "../../store/studentMaster/StudentMasterSlice";
import { THEME } from "../../util/LookupConst";
import SameAsAbove from "../../component/sameAsAbove/SameAsAbove";

interface ParentInfoProps {
  handleDrawerClose?: any;
  handleDrawerOpen?: any;
  setModalOpenSchool?: any;
  values: any;
  handleBlur: any;
  errors: any;
  touched: any;
  setFieldValue: any;
  handleChange: any;
  primaryBenefitOptions: any;
  countryOptions: any;
  setDisable: any;
  isDisable: any;
  courseNameOptions: any;
}

const ParentInfo = (props: ParentInfoProps) => {
  const {
    handleChange,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    setDisable,
    isDisable,
    courseNameOptions,
  } = props;
  const { values, primaryBenefitOptions, countryOptions } = props;

  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [country, setCountry] = useState([]);
  const [mobileNumber, setMobileNumber] = useState("");
  //const [otpValue, setOTPValue] = useState("");
  const [spinner, setSpinner] = useState<boolean>(false);
  const [sameAsAbove, setSameAsAbove] = useState<any>(true);
  const countryIndia = LoginUserDetails.getCountry() === "India";

  const handleSwitchChange = (value: boolean) => {
    setSameAsAbove(value);
  };

  useEffect(() => {
    if ((values.courseId === 2 || values.courseId === 4) && countryIndia) {
      const countrylist = CommonUtil.copyObject(countryOptions);
      countrylist.shift();
      setCountry(countrylist);
      setFieldValue("countryId", values.countryId || countryOptions[1]?.value);
    } else {
      setCountry(countryOptions);
      setFieldValue(
        "countryId",
        countryIndia
          ? countryOptions[0]?.value
          : countryOptions?.find(
              (country: any) => country.label === LoginUserDetails.getCountry()
            ).value
      );
    }

    // setSameAsAbove(
    //   values.primaryMobileNumber !== "" &&
    //     values.primaryMobileNumber === values.whatsappMobileNumber
    // );
  }, []);

  const query = require("india-pincode-search");

  const handlePincodeChange = (e: any) => {
    setFieldValue("pincode", e.target.value);
    if (e.target.value.length === 6) {
      const areaDetails: any = query?.search(e.target.value)[0];
      setFieldValue("state", areaDetails?.state || "");
      setFieldValue("city", areaDetails?.city || "");
      setFieldValue("area", areaDetails?.office || "");
    }
  };

  // const sendOTP = (e: any) => {
  //   const mobileNo = e.target.value;
  //   setSpinner(true);
  //   dispatch(
  //     studentMasterService({
  //       apiAction: "sendOTP",
  //       mobileNumber: mobileNo.toString(),
  //     })
  //   )
  //     .then((result: any) => {
  //       if (result?.payload?.status === 200) {
  //         Toaster.success(undefined, result.payload.data.message);
  //       } else {
  //         Toaster.error(undefined, result.payload);
  //       }
  //     })
  //     .catch(() => {})
  //     .finally(() => {
  //       setSpinner(false);
  //     });
  // };

  //We need it for future
  // const verifyOTP = () => {
  //   setSpinner(true);
  //   dispatch(
  //     studentMasterService({
  //       apiAction: "verifyOTP",
  //       mobileNumber: mobileNumber,
  //       otp: otpValue,
  //     })
  //   )
  //     .then((result: any) => {
  //       if (result?.payload?.status === 200) {
  //         Toaster.success(undefined, result.payload.data.message);
  //       } else {
  //         Toaster.error(undefined, result.payload);
  //       }
  //     })
  //     .catch(() => {})
  //     .finally(() => {
  //       setSpinner(false);
  //     });
  // };

  //Mobile number already exist validation
  const handleExistsMobileNo = (e: any) => {
    if (e.target.value.length === mobileNumber.length) {
      //setSpinner(true);
      dispatch(
        studentMasterService({
          requestParam: `/mobileNo/${e.target.value}?id=${values.id || ""}`,
          apiAction: "verifyMobileNo",
        })
      )
        .then((result: any) => {
          if (result?.payload?.status === 200) {
            if (
              result?.payload?.data?.message?.split("-")[1] > 0 &&
              Product.ProductCode() === THEME.SA
            )
              Toaster.warning(
                undefined,
                `${t("Are you registering for sibilings?")}`,
                mycallback,
                true,
                ""
              );
            const { mobileNo, ...rest } = isDisable;
            setDisable(rest);
            //sendOTP(e);
          } else {
            setDisable((pre: any) => ({ ...pre, mobileNo: result.payload }));
            Toaster.error(undefined, result.payload);
          }
        })
        .catch((err: any) => {
          // This console for debug the app if any error occurred in DEV
          console.log(err);
        })
        .finally(() => {
          setSpinner(false);
        });
    }
  };

  const mycallback = (message: string) => {
    if (!message) {
      setFieldValue("primaryMobileNumber", "");
      setFieldValue("whatsappMobileNumber", "");
    }
  };

  return (
    <Grid className="sidenav-container ">
      <Box className="full">
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 1 }}
        >
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <div style={{ paddingRight: "20px" }}>
              <Label required title={t("primaryParentGuardianName")} />
              <Field
                className="textFiled"
                name="parentName"
                placeholder={t("enterHere")}
                value={values.parentName}
                onChange={handleChange}
                onBlur={handleBlur}
                max={255}
                helperText={<ErrorMessage name="parentName" />}
                error={errors.parentName && touched.parentName}
              />
              <div className="form-ele-gap inherit-number-field">
                <Label required title={t("primaryMobileNumber")} />
                <Field
                  className="textFiled"
                  name="primaryMobileNumber"
                  placeholder={t("enterHere")}
                  value={values.primaryMobileNumber}
                  type="number"
                  onInput={
                    courseNameOptions
                      .find((course: any) => course.value === values.courseId)
                      .label.indexOf("International") < 0 && countryIndia
                      ? (e: any) => CommonUtil.checkLengthHandler(e, 10)
                      : ""
                  }
                  onChange={(e: any) => {
                    handleChange(e);
                    sameAsAbove &&
                      setFieldValue("whatsappMobileNumber", e.target.value);
                    setMobileNumber(e.target.value);
                  }}
                  onBlur={(e: any) => {
                    handleExistsMobileNo(e);
                    handleBlur(e);
                  }}
                  helperText={<ErrorMessage name="primaryMobileNumber" />}
                  error={
                    errors.primaryMobileNumber && touched.primaryMobileNumber
                  }
                />
              </div>
              {/* We need it for future */}
              {/* <div style={{ marginTop: "6px" }}>
                <div>
                  <Label title={t("Enter OTP")} />
                </div>
                <div>
                  <OTPInput
                    length={4}
                    className="otpContainer margin-down-20 inline-flex"
                    inputClassName="otpInput"
                    isNumberInput
                    autoFocus
                    onChangeOTP={(otp) => setOTPValue(otp)}
                  />
                  <CheckCircle
                    style={{
                      color: "green",
                      marginTop: "15px",
                      fontSize: "18px",
                    }}
                    onClick={() => {
                      verifyOTP();
                    }}
                  />
                </div>
              </div> */}
              <div style={{ marginTop: "12px" }}></div>
              <div className=" inherit-number-field">
                <div style={{ display: "flex", gap: "90px" }}>
                  <div>
                    <Label required title={t("whatsAppMobileNumber")} />
                  </div>
                  <div style={{ display: "flex", alignItems: "flex-end" }}>
                    <SameAsAbove
                      values={values}
                      setFieldValue={setFieldValue}
                      switchChange={handleSwitchChange}
                    ></SameAsAbove>
                  </div>
                </div>
                <Field
                  className="textFiled"
                  name="whatsappMobileNumber"
                  disabled={sameAsAbove}
                  placeholder={t("enterHere")}
                  value={values.whatsappMobileNumber}
                  type="number"
                  onInput={
                    courseNameOptions
                      .find((course: any) => course.value === values.courseId)
                      .label.indexOf("International") < 0
                      ? (e: any) => CommonUtil.checkLengthHandler(e, 10)
                      : ""
                  }
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={<ErrorMessage name="whatsappMobileNumber" />}
                  error={
                    errors.whatsappMobileNumber && touched.whatsappMobileNumber
                  }
                />
              </div>

              <div className="form-ele-gap inherit-number-field">
                <Label title={t("alternateMobileNumber")} />
                <Field
                  className="textFiled"
                  name="alternateMobileNumber"
                  placeholder={t("enterHere")}
                  value={values.alternateMobileNumber}
                  type="number"
                  onInput={
                    courseNameOptions
                      .find((course: any) => course.value === values.courseId)
                      .label.indexOf("International") < 0 && countryIndia
                      ? (e: any) => CommonUtil.checkLengthHandler(e, 10)
                      : ""
                  }
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={<ErrorMessage name="alternateMobileNumber" />}
                  error={
                    errors.alternateMobileNumber &&
                    touched.alternateMobileNumber
                  }
                />
              </div>
              <div className="form-ele-gap">
                <Label title={t("email")} />
                <Field
                  name="email"
                  placeholder={t("enterHere")}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  max={255}
                  helperText={<ErrorMessage name="email" />}
                  error={errors.email && touched.email}
                />
              </div>

              <div className="form-ele-gap ">
                <Label required title={t("primaryBenefitYouExpact")} />
                <SelectField
                  name="primaryBenefitYouExpectId"
                  defaultValue={t("enterHere")}
                  value={values.primaryBenefitYouExpectId || t("select")}
                  onChange={handleChange}
                  options={primaryBenefitOptions}
                />
              </div>
            </div>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={6}>
            <div>
              <div className="autocomplete-form">
                <Label required title={t("country")} />
                <SelectField
                  disabled={values.courseId === 1 || values.courseId === 3}
                  name="countryId"
                  placeholder={t("enterHere")}
                  value={values.countryId}
                  onChange={handleChange}
                  options={country}
                />
              </div>

              <div className="form-ele-gap inherit-number-field">
                <Label
                  required={
                    courseNameOptions
                      .find((course: any) => course.value === values.courseId)
                      .label.indexOf("International") < 0 &&
                    LoginUserDetails.getCountry() === "India"
                  }
                  title={
                    LoginUserDetails.getCountry() === "United States"
                      ? "Zip Code"
                      : t("pinCode")
                  }
                />
                <Field
                  className="textFiled"
                  placeholder={t("enterHere")}
                  name="pincode"
                  type={
                    LoginUserDetails.getCountry() === "United States"
                      ? "text"
                      : "number"
                  }
                  onInput={
                    LoginUserDetails.getCountry() === "India"
                      ? (e: any) => CommonUtil.checkLengthHandler(e, 6)
                      : ""
                  }
                  value={values.pincode}
                  onChange={(e: any) => {
                    if (
                      courseNameOptions
                        .find((course: any) => course.value === values.courseId)
                        .label.indexOf("International") < 0 &&
                      countryIndia
                    ) {
                      handlePincodeChange(e);
                    }
                    handleChange(e);
                  }}
                  onBlur={handleBlur}
                  helperText={<ErrorMessage name="pincode" />}
                  error={errors.pincode && touched.pincode}
                />
              </div>
              <div style={{ marginTop: "32px" }}>
                <Label title={t("state")} />
                <Field
                  disabled={countryIndia}
                  placeholder={t("stateName")}
                  className="textFiled"
                  name="state"
                  value={values.state}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={<ErrorMessage name="state" />}
                  error={errors.state && touched.state}
                />
              </div>
              <div className="form-ele-gap">
                <Label title={t("city")} />
                <Field
                  //disabled={values.courseId === 1 || values.courseId === 3}
                  placeholder={t("cityName")}
                  className="textFiled"
                  name="city"
                  value={values.city}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={<ErrorMessage name="city" />}
                  error={errors.city && touched.city}
                />
              </div>
              <div className="form-ele-gap">
                <Label
                  title={
                    LoginUserDetails.getCountry() === "India"
                      ? t("area")
                      : " County Name"
                  }
                />
                <Field
                  //disabled={values.courseId === 1 || values.courseId === 3}
                  placeholder={
                    LoginUserDetails.getCountry() === "India"
                      ? t("areaName")
                      : " County Name"
                  }
                  className="textFiled"
                  name="area"
                  value={values?.area}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>
              <div className="form-ele-gap">
                <Label title={t("address")} />
                <Field
                  name="address"
                  placeholder={t("enterHere")}
                  value={values?.address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  max={255}
                  helperText={<ErrorMessage name="address" />}
                  error={errors.address && touched.address}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>

      <GlobalLoader loading={spinner} />
    </Grid>
  );
};

export default ParentInfo;
